document.addEventListener('DOMContentLoaded', function () {
  const articleContent = document.querySelector('.js-article-content');

  if (!articleContent) return;

  const allElements = Array.from(articleContent.children);

  const faqHeading = allElements.find((element) => {
    if (!/^H[1-6]$/.test(element.tagName)) return false;

    const text = element.textContent
      .trim()
      .toLowerCase()
      .replace(/[:?]/g, '');

    return (
      text === 'faq' ||
      text === 'faqs' ||
      text.includes('frequently asked questions')
    );
  });

  if (!faqHeading) return;

  const existingFaqItems = [
    ...articleContent.querySelectorAll('.faq-item')
  ];

  if (existingFaqItems.length) {
    const mainEntity = existingFaqItems
      .map((item) => {
        const question = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');

        if (!question || !answer) return null;

        const questionText = question.textContent
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        const answerText = answer.textContent
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        if (!questionText || !answerText) return null;

        return {
          '@type': 'Question',
          name: questionText,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answerText
          }
        };
      })
      .filter(Boolean);

    if (mainEntity.length) {
      document
        .querySelectorAll(
          'script[data-article-faq-schema="true"]'
        )
        .forEach((script) => script.remove());

      const schemaScript = document.createElement('script');

      schemaScript.type = 'application/ld+json';

      schemaScript.setAttribute(
        'data-article-faq-schema',
        'true'
      );

      schemaScript.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity
      });

      document.head.appendChild(schemaScript);

      return;
    }
  }

  const faqHeadingIndex = allElements.indexOf(faqHeading);

  let faqEndIndex = allElements.length;

  for (
    let index = faqHeadingIndex + 1;
    index < allElements.length;
    index++
  ) {
    const element = allElements[index];

    if (!/^H[1-6]$/.test(element.tagName)) continue;

    const text = element.textContent
      .trim()
      .toLowerCase()
      .replace(/[:?]/g, '');

    if (
      text === 'conclusion' ||
      text === 'summary' ||
      text === 'final thoughts'
    ) {
      faqEndIndex = index;
      break;
    }
  }

  const faqElements = allElements.slice(
    faqHeadingIndex + 1,
    faqEndIndex
  );

  const faqs = [];

  let currentQuestion = null;
  let currentQuestionElement = null;
  let answerNodes = [];

  function isQuestion(element) {
    if (!element) return false;

    if (/^H[2-6]$/.test(element.tagName)) {
      return true;
    }

    if (element.tagName === 'P') {
      const boldElement = element.querySelector('strong, b');

      if (!boldElement) return false;

      const fullText = element.textContent.trim();
      const boldText = boldElement.textContent.trim();

      const mostlyBold =
        fullText === boldText ||
        fullText.startsWith(boldText);

      return (
        mostlyBold &&
        (
          fullText.endsWith('?') ||
          /^(q|question)\s*[:.-]/i.test(fullText)
        )
      );
    }

    return false;
  }

  function getQuestionText(element) {
    return element.textContent
      .trim()
      .replace(/^(q|question)\s*[:.-]\s*/i, '');
  }

  function saveFaq() {
    if (
      !currentQuestion ||
      !currentQuestionElement ||
      answerNodes.length === 0
    ) {
      return;
    }

    faqs.push({
      question: currentQuestion,
      questionElement: currentQuestionElement,
      answers: [...answerNodes]
    });

    currentQuestion = null;
    currentQuestionElement = null;
    answerNodes = [];
  }

  faqElements.forEach((element) => {
    if (isQuestion(element)) {
      saveFaq();

      currentQuestion = getQuestionText(element);
      currentQuestionElement = element;
      answerNodes = [];

      return;
    }

    if (currentQuestion) {
      answerNodes.push(element);
    }
  });

  saveFaq();

  if (!faqs.length) return;

  const accordion = document.createElement('div');

  accordion.className = 'article-faq-accordion';

  faqs.forEach((faq, index) => {
    const item = document.createElement('div');

    item.className = 'article-faq-item';

    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'article-faq-question';

    button.setAttribute(
      'aria-expanded',
      'false'
    );

    button.setAttribute(
      'aria-controls',
      `article-faq-answer-${index}`
    );

    const title = document.createElement('span');

    title.className = 'article-faq-question-text';
    title.textContent = faq.question;

    const icon = document.createElement('span');

    icon.className = 'article-faq-icon';

    icon.setAttribute(
      'aria-hidden',
      'true'
    );

    icon.textContent = '+';

    button.append(title, icon);

    const answer = document.createElement('div');

    answer.className = 'article-faq-answer';
    answer.id = `article-faq-answer-${index}`;
    answer.hidden = true;

    const answerInner = document.createElement('div');

    answerInner.className = 'article-faq-answer-inner';

    faq.answers.forEach((node) => {
      answerInner.appendChild(node);
    });

    answer.appendChild(answerInner);

    button.addEventListener('click', function () {
      const isExpanded =
        button.getAttribute('aria-expanded') === 'true';

      button.setAttribute(
        'aria-expanded',
        String(!isExpanded)
      );

      answer.hidden = isExpanded;

      icon.textContent =
        isExpanded ? '+' : '−';

      item.classList.toggle(
        'is-open',
        !isExpanded
      );
    });

    item.append(button, answer);

    accordion.appendChild(item);

    faq.questionElement.remove();
  });

  faqHeading.insertAdjacentElement(
    'afterend',
    accordion
  );

  const faqSchemaItems = [];

  accordion
    .querySelectorAll('.article-faq-item')
    .forEach(function (item) {
      const questionElement =
        item.querySelector(
          '.article-faq-question-text'
        );

      const answerElement =
        item.querySelector(
          '.article-faq-answer'
        );

      if (!questionElement || !answerElement) {
        return;
      }

      const questionText =
        questionElement.textContent
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      const answerText =
        answerElement.textContent
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      if (!questionText || !answerText) {
        return;
      }

      faqSchemaItems.push({
        '@type': 'Question',
        name: questionText,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerText
        }
      });
    });

  if (faqSchemaItems.length > 0) {
    const existingFaqSchema =
      document.querySelector(
        'script[data-article-faq-schema="true"]'
      );

    if (existingFaqSchema) {
      existingFaqSchema.remove();
    }

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqSchemaItems
    };

    const schemaScript =
      document.createElement('script');

    schemaScript.type =
      'application/ld+json';

    schemaScript.setAttribute(
      'data-article-faq-schema',
      'true'
    );

    schemaScript.textContent =
      JSON.stringify(faqSchema);

    document.head.appendChild(schemaScript);
  }
});
